"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPassengersMainTime = exports.getMfus = exports.ambleaLegalInformations = exports.dispatchStatuses = exports.manualDispatchStatuses = exports.PayerEnum = exports.fullExportOptions = exports.anonymousExportOptions = exports.isFichCompFormat = exports.exportExtensions = void 0;
var lodash_1 = require("lodash");
var utils_1 = require("./utils");
exports.exportExtensions = {
    PASSENGERS_XLSX: 'xlsx',
    PASSENGERS_CSV: 'csv',
    PASSENGERS_ANON_XLSX: 'xlsx',
    PASSENGERS_ANON_CSV: 'csv',
    FICHCOMP_MCO_TXT: 'txt',
    FICHCOMP_SSRPSY_TXT: 'txt',
    FICHCOMP_PSY_TXT: 'txt',
    FICHCOMP_SSR_TXT: 'txt',
    POOLING_AND_CIRCUIT_XLSX: 'xlsx',
    ATTENDANCE_SHEET: 'pdf',
};
var isFichCompFormat = function (requestType) {
    return (0, utils_1.isIn)(['FICHCOMP_MCO_TXT', 'FICHCOMP_SSRPSY_TXT', 'FICHCOMP_PSY_TXT', 'FICHCOMP_SSR_TXT'], requestType);
};
exports.isFichCompFormat = isFichCompFormat;
exports.anonymousExportOptions = ['PASSENGERS_ANON_XLSX', 'PASSENGERS_ANON_CSV'];
exports.fullExportOptions = ['PASSENGERS_XLSX', 'PASSENGERS_CSV', 'ATTENDANCE_SHEET'];
exports.PayerEnum = {
    GOV: 'GOV',
    PTNT: 'PTNT',
    HPTL_A: 'HPTL_A',
    HPTL_B: 'HPTL_B',
    TPS_A: 'TPS_A',
    HPTL_A_NOTART80: 'HPTL_A_NOTART80',
};
exports.manualDispatchStatuses = [
    'WAIT_HPTL_DISPATCH',
    'WAIT_TC_DISPATCH',
    'PRIORITY_DISPATCH',
    'URGENT_DISPATCH',
];
exports.dispatchStatuses = __spreadArray(__spreadArray([], exports.manualDispatchStatuses, true), [
    'WAIT_GI_TPTR_APPROVAL',
    'WAIT_AUTO_TPTR_APPROVAL',
], false);
var amblerSiret = '84085930000047';
exports.ambleaLegalInformations = {
    legalForm: 'SAS',
    name: 'Amblea',
    shareCapital: 1885210,
    siret: amblerSiret,
    siren: amblerSiret.slice(0, 9),
    vatNumber: 'FR83840859300',
    invoicingAdress: '128 rue de la Boétie, 75008, Paris',
};
// Note: `trips` and `passengers` are marked as optionnal to match Prisma 1 typing.
var getMfus = function (mission) {
    if (!mission) {
        return [];
    }
    if (!mission.trips) {
        throw new Error('Mission has no trips');
    }
    var passengers = mission.trips.flatMap(function (trip) {
        if (!trip.passengers) {
            throw new Error('Trip has no passengers');
        }
        return trip.passengers;
    });
    var mfus = (0, lodash_1.uniqBy)(passengers.map(function (p) { return p.mfu; }), 'id');
    return mfus;
};
exports.getMfus = getMfus;
var getPassengersMainTime = function (timeRef) {
    return timeRef === 'ARRIVAL' ? 'departureTime' : 'arrivalTime';
};
exports.getPassengersMainTime = getPassengersMainTime;
//# sourceMappingURL=misc.js.map